export const WALLETCONNECT_PROJECT = process.env.REACT_APP_WALLETCONNECT_PROJECT_ID || '';
export const API = process.env.REACT_APP_API || '';
export const DEFAULT_ERROR_MESSAGE = 'An error has occurred. Please, try again';
export const QUERY_ENABLED = process.env.REACT_APP_QUERY_ENABLED === 'true';
export const SUPPORTED_NETWORKS =
  process.env.REACT_APP_SUPPORTED_NETWORKS?.replace(/\s/g, '')?.split(',') || ([] as string[]);
export const POLLING_INTERVAL = process.env.REACT_APP_POLLING_INTERVAL || '';
